<ion-button
  *ngIf="buttonTriggered === 'REJECT'"
  [color]="'danger'"
  (click)="getCancelReasons()"
  class="status-btn ion-text-uppercase"
>
  <ion-icon
    name="close"
    color="light"
    class="ion-float-left icon-padding"
  ></ion-icon>
  CANCEL
</ion-button>
<ion-button
  *ngIf="buttonTriggered === 'HOLD'"
  (click)="getCancelReasons()"
  [color]="'medium'"
  class="ion-text-uppercase status-btn"
>
  <ion-icon
    name="pause"
    color="light"
    class="ion-float-left icon-padding"
  ></ion-icon>
  HOLD
</ion-button>
